module.exports = __webpack_public_path__ + "bnlogo.61c82c211d66347ec673.png";